import React, { useEffect } from 'react';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Solutions from './components/Solutions';
import CTAStrip from './components/CTAStrip';
import AnimationShowcase from './components/AnimationShowcase';
import Industries from './components/Industries';
import WhyChoose from './components/WhyChoose';
import Testimonials from './components/Testimonials';
import Assistance from './components/Assistance';
import Footer from './components/Footer';
import { useNav } from './hooks/useNav';
import { useScrollReveal } from './hooks/useScrollReveal';
import { useCanvasAnimations } from './hooks/useCanvasAnimations';

function App() {
  useNav();
  useScrollReveal();
  useCanvasAnimations();

  return (
    <>
      {/* Progress dots */}
      <div className="progress-dots" id="progressDots">
        <div className="pdot active" data-target="hero" title="Home"></div>
        <div className="pdot" data-target="solutions" title="Solutions"></div>
        <div className="pdot" data-target="hiw" title="How It Works"></div>
        <div className="pdot" data-target="industries" title="Industries"></div>
        <div className="pdot" data-target="why" title="Why Us"></div>
        <div className="pdot" data-target="assist" title="Contact"></div>
      </div>

      {/* Back to top */}
      <button className="back-top" id="backTop" aria-label="Back to top">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="19" x2="12" y2="5" />
          <polyline points="5 12 12 5 19 12" />
        </svg>
      </button>

      <Nav />
      <Hero />
      <Solutions />
      <CTAStrip />
      <AnimationShowcase />
      <Industries />
      <WhyChoose />
      <Testimonials />
      <Assistance />
      <Footer />
    </>
  );
}

export default App;
